import { safeDefineFsComponent } from '@cof/safe-custom-element-define';
import { FsTooltip as Tooltip } from './src/Tooltip.js';
const { customElementClass, safeTagName } = safeDefineFsComponent.define(Tooltip);
export const FsTooltip = customElementClass;
export const tagName = safeTagName;
//# sourceMappingURL=fs-tooltip.js.map